import React, { useState } from "react";
import { Footer } from '../../components/footer/Footer';

const personaQuizPic = '/org/gds/gear.png';

function OrientationPage() {
      const [errorMessage, setErrorMessage] = useState("");

  return (
    <div id="pageContainer" className="pageContainer" >
        <style>{`
          /*
            PersonaQuizPage.scss (imported by this page) styles .personaQuizPageContainer
            (JSX actually uses .pageContainer) and .personaQuizPic (JSX actually uses
            .preferencesPic on the logo img) and its responsive blocks target
            .personaQuiz-container (JSX uses .personaQuizContainer, no hyphen) - none of
            those match, so background/logo sizing/responsive rules never applied here.
            This block targets the classes actually used below, !important-guarded, using
            the same palette/layout as SignUpPage.tsx and PreferencesPage.tsx. The old
            margin-top:6vh/8vh/5vh on .pageImageContainer (viewport-height relative) is
            also why the logo drifted on resize - replaced with a fixed top position.
          */
          body, html, #root {
            background-color: #551540 !important;
          }
          #pageContainer, .pageContainer {
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            width: 100% !important;
            min-height: 100vh !important;
            height: auto !important;
            background-color: #551540 !important;
            color: #F3F1E8 !important;
            padding: 24px 16px 64px !important;
            box-sizing: border-box !important;
            overflow-x: hidden !important;
          }
          #pageContainer * {
            box-sizing: border-box;
          }
          #personaQuizContainer, .personaQuizContainer {
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
            width: 100% !important;
            max-width: 720px !important;
            margin: 0 auto !important;
            gap: 0 !important;
          }
          .pageImageContainer, #pageImageContainer {
            width: 100% !important;
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
            margin: 0 auto 12px !important;
          }
          .preferencesPic, #preferencesPic {
            width: 90px !important;
            max-width: 90px !important;
            height: auto !important;
            margin: 0 auto !important;
            display: block !important;
          }
          .personaQuizTitle {
            text-align: center !important;
            width: 100% !important;
            margin: 0 auto 14px !important;
            color: #F3F1E8 !important;
            font-size: 1.3rem !important;
            font-weight: 600 !important;
          }
          .personaQuiz-card {
            width: 100% !important;
            margin: 0 auto 16px !important;
          }
          .personaQuizSubTitle {
            margin: 0 0 8px !important;
          }
          .personaQuizDescriptionText {
            margin: 0 !important;
            max-width: 100% !important;
          }
          .personaQuizContent {
            width: 100% !important;
            display: flex !important;
            flex-direction: column !important;
            align-items: center !important;
          }
          .orientationMessage {
            width: 100% !important;
            background: #fff !important;
            color: #222 !important;
            border-radius: 1.5rem !important;
            padding: 1.25rem !important;
            margin: 0 0 16px !important;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1) !important;
            text-align: left !important;
          }
          .personaQuizButtonContainer {
            display: flex !important;
            flex-wrap: wrap !important;
            justify-content: center !important;
            gap: 12px !important;
            width: 100% !important;
            max-width: 300px !important;
            margin: 12px auto 0 !important;
          }
          .signUpButton, .signInButton {
            flex: 1 1 130px !important;
            max-width: 190px !important;
            padding: 10px 18px !important;
            border: none !important;
            border-radius: 24px !important;
            font-weight: 600 !important;
            cursor: pointer !important;
          }
          .signUpColor {
            background-color: #551540 !important;
            color: #F3F1E8 !important;
          }
          @media (max-width: 480px) {
            .preferencesPic, #preferencesPic {
              width: 70px !important;
              max-width: 70px !important;
            }
            .personaQuizButtonContainer {
              flex-direction: column !important;
              align-items: stretch !important;
              max-width: 100% !important;
            }
          }
        `}</style>
      <div id="personaQuizContainer" className="personaQuizContainer">

        {/* Logo: fixed at top, centered - matches SignUpPage/PreferencesPage */}
        <div id="pageImageContainer" className="pageImageContainer">
            <img
            id="preferencesPic"
            className="preferencesPic"
            src={personaQuizPic}
            alt="Company Logo"
            />
        </div>

        <div className="personaQuizTitle"> Coach Yourself To Win - Persona Quiz</div>

        <div className="personaQuiz-card">
            <div className="headerContainer">
            <h2 className='personaQuizSubTitle'>Coach Yourself To Win</h2>

            <div className="personaQuizDescription">
                <div className="personaQuizDescriptionText">
                    <p>This is a preliminary High-Performance survey to help us get started.
                    We will create a curriculum for you based on your replies, which you may change later.
                    For each question, you can rate yourself on a scale from 1 to 5, where 1 means "Strongly Disagree" and 5 means "Strongly Agree."</p>
                </div>
                <hr className="horiz-rule"></hr>
            </div>
            </div>
        </div>

        <div className="personaQuizContent">
            <div className="orientationMessage">
            <div className="orientationText">

            <h4>What is Lorem Ipsum?</h4>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>
             </div>
            </div>
            <hr className="horiz-rule"/>
             {/* Error Message Display */}
            {errorMessage && <div className="errorStatus" style={{width:"100%"}}>{errorMessage}</div>}

            {/* Buttons */}
            <div className="personaQuizButtonContainer">
                <button className="signUpButton signUpColor" type="button"
                    onClick={() => window.location.assign("/setup/")}>
                   Go Back
                </button>

              <button
                id="personaQuizButton"
                className="signInButton signUpColor"
                type="button"
                onClick={() => window.location.assign("/ibot?id=asst_PB5ZB5l02xJZWPCCNhQGZgXd")}
            >Next</button>
            </div>
        </div>

      </div>
    <Footer />
    </div>
  );
}

export default OrientationPage;
